module.exports = __webpack_public_path__ + "static/media/skybox_external_view_pc.b399aea3.jpg";